module.exports = __webpack_public_path__ + "static/img/16.6e8e08b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mohu/3/16.png
// module id = bUrM
// module chunks = 0